import {
  IInsuranceContractSummary,
  ITenderType,
  IUnderwriterSummary,
} from '@nibtravel/shared/util/models';

/** Type that represents the mapping between UnderwriterCode and its ids */
export type UnderwritersMap = Record<string, IUnderwriterSummary>;

/** Type that represents the mapping between contract Id and contract summary */
export type ContractsMap = Record<number, IInsuranceContractSummary>;

/** Type that represents the mapping between Underwriter Content type and its content */
export type UnderwriterContentMap = Record<string, string>;

/** Type that represents the mapping between a contract id and its underwriter content */
export type ContractContentMap = Record<number, UnderwriterContentMap>;

/** Type that represents the contract id and its card tender types */
export type TenderTypeMap = Record<number, ITenderType[]>;

/**
 * Type that represents the mapping between plan id to contract id
 * NOTE: Plan Id's should be unique accross the brand and so is the contract id
 */
export type PlanToContractMap = Record<number, number>;

export interface IUnderwriterState {
  tenderTypeMap: TenderTypeMap;
  underwritersMap: UnderwritersMap;
  contractsMap: ContractsMap;
  contractContentMap: ContractContentMap;
  planToContractMap: PlanToContractMap;
  currentContractId?: number;
}

export const defaultUnderwriterState: IUnderwriterState = {
  tenderTypeMap: {},
  underwritersMap: {},
  contractsMap: {},
  contractContentMap: {},
  planToContractMap: {},
};
